/* eslint spaced-comment: ["error", "always"] */
/* eslint-disable */

import { Plugin } from '@devexpress/dx-react-core';
import {
  Column,
  CustomPaging,
  DataTypeProvider,
  EditingState,
  IntegratedSelection,
  PagingState,
  SelectionState,
  Sorting,
  SortingState,
  TableColumnWidthInfo,
} from '@devexpress/dx-react-grid';
import {
  DragDropProvider,
  Grid,
  PagingPanel,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableEditRow,
  TableFixedColumns,
  TableHeaderRow,
  TableSelection,
} from '@devexpress/dx-react-grid-material-ui';
import { Button, IconButton, Paper, SvgIcon, Tooltip } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import CachedIcon from '@material-ui/icons/Cached';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import EventIcon from '@material-ui/icons/Event';
import GetAppIcon from '@material-ui/icons/GetApp';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { ReactComponent as SvgSortIcon } from 'assets/sorticon.svg';
import { Hide } from 'components';
import {
  DataTypeEditors,
  DataTypeFormatters,
} from 'components/atoms/CustomGridComponents/DataTypeProvider';
import Loading from 'components/atoms/Loading';
import WrapperWithTooltip from 'components/atoms/WrapperWithTooltip';
import * as CriticalityColors from 'components/molecules/AnomalyGrid/colors/pallete-colors';
import GridModalCancel from 'components/molecules/GridModalCancel';
import GridModalDelete from 'components/molecules/GridModalDelete';
import { CRITICALITY_DEGREE } from 'constants/anomaly/index';
import { GROUPS } from 'constants/permissions';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useAuth } from 'hooks/useAuth';
// import { debounce } from 'lodash';
// alterar em prod
import { isNumber, debounce } from 'lodash';
import React, { useLayoutEffect, useRef, useState } from 'react';

import { useQuery, useQueryClient } from 'react-query';
import {
  deleteActivityPlanned,
  getActivityMaintenanceType,
  getYesOrNotOption,
  postActivityUpdate,
  postCancelActivity,
} from 'services/activity';
import { getExecutorOptions } from 'services/executor';
import { getJustificationOptions } from 'services/justification';
import { colors } from 'styles/colors';
import ModalFinish from './components/ModalFinish';
import ModalAdd from './components/ModalAdd';
import ModalComments from './components/ModalComments';
import ModalPause from './components/ModalPause';
import ModalReplanning from './components/ModalReplanning';
import ModalUnpause from './components/ModalUnpause';
import ModalStartInspection from '../ModalStartInspection';
import ModalStart from './components/ModalStart';

import useStyles from './style';
import {
  ICommentsRow,
  IGrid,
  IRow,
  ISelectOption,
  IValidationRules,
} from './types';

dayjs.extend(duration);

const pagingPanelMessages = {
  showAll: 'Todos',
  rowsPerPage: 'Linhas por página',
  info: ({ from, to, count }) => `${from}-${to} de ${count}`,
};
const tableMessages = {
  noData: 'Sem dados disponíveis',
};

const PluginComments = ({ commentRow, onClose }) => {
  const open = React.useMemo(
    () => Boolean(Object.keys(commentRow).length),
    [commentRow],
  );

  return (
    <Plugin name="PluginComments">
      <ModalComments open={open} gridRow={commentRow} onClose={onClose} />
    </Plugin>
  );
};

const PlanningGrid = ({
  rows,
  columns,
  orderOfColumns,
  widthOfColumns,
  tooltipMaxStrLength,
  fixedLeftColumns = [],
  buttonCells = [],
  tooltipCells = [],
  statusCells = [],
  dayMonthCells = [],
  dayMonthYearCells = [],
  dateCells = [],
  durationCells = [],
  dateTimeCells = [],
  externalLinkCells = [],
  yesOrNotCells = [],
  percentageCells = [],
  validationRules,
  refetch,
  onSaveGridConfiguration,
  onCurrentPageChange,
  onPageSizeChange,
  onSortingChange,
  getRowId,
  getRowById,
  currentPage,
  pageSize,
  pageSizes,
  totalCount,
  loading,
  expandAccordion,
  setExpandAccordion,
  onExport,
}: IGrid) => {
  // TODO HERLAN: escrever testes!
  const classes = useStyles();
  const { checkPermissions } = useAuth();

  const [commentRow, setCommentRow] = React.useState<ICommentsRow>({});

  const [openModalPause, setOpenModalPause] = useState<boolean>(false);
  const [openModalFinish, setOpenModalFinish] = React.useState<boolean>(false);
  const [modalReplannig, setModalReplanning] = useState<boolean>(false);
  const [modalUnpause, setModalUnpause] = useState<boolean>(false);
  const [modalAdd, setModalAdd] = useState<boolean>(false);
  const [modalCancel, setModalCancel] = useState<boolean>(false);
  const [modalDelete, setModalDelete] = React.useState<boolean>(false);
  const [columnOrder, setColumnOrder] = useState(orderOfColumns);
  const [selection, setSelection] = useState<(string | number)[]>([]);
  const [editingRowIds, setEditingRowIds] = useState<(string | number)[]>([]);
  const [rowChanges, setRowChanges] = useState({});

  const [errors, setErrors] = useState<IValidationRules>({});
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const [updatingGridData, setUpdatingGridData] = useState<boolean>(false);

  const [yesOrNotOptions, setYesOrNotOptions] = React.useState<ISelectOption[]>(
    [],
  );
  const [typeMaintranceOptions, setTypeMaintenance] = React.useState<
    ISelectOption[]
  >([]);
  const [executorOptions, setExecutorOptions] = React.useState<ISelectOption[]>(
    [],
  );
  const [justificationOptions, setJustificationOptions] = React.useState<
    ISelectOption[]
  >([]);

  const [modalStarInspection, setModalStartInspection] =
    React.useState<boolean>(false);
  const [openModalStart, setOpenModalStart] = React.useState<boolean>(false);

  const gridRef = useRef<HTMLElement>();
  const scrollDivRef = useRef<HTMLDivElement>(null);
  const hiddenScrollDivRef = useRef<HTMLDivElement>(null);

  const queryClient = useQueryClient();

  const queryYesOrNot = useQuery({
    queryKey: ['outageOptionsContext'],
    queryFn: async () => {
      const { data } = await getYesOrNotOption({});
      return data;
    },
    select: data => {
      return Object.values(data).map(value => {
        return {
          label: value && value === 'S' ? 'Sim' : 'Não',
          value,
        };
      });
    },
    onSuccess: (data: ISelectOption[]) => {
      setYesOrNotOptions(data);
    },
    enabled: isEditing,
  });

  const queryMaintenanceTypeOptions = useQuery({
    queryKey: ['maintenanceTypeOptions'],
    queryFn: async () => {
      const { data } = await getActivityMaintenanceType({});

      return data;
    },
    select: data => {
      return data.map(item => {
        return {
          label: item?.description,
          value: item?.description,
        };
      });
    },
    onSuccess: (data: ISelectOption[]) => {
      setTypeMaintenance(data);
    },
    enabled: isEditing,
  });

  const queryExecutorAllOptions = useQuery({
    queryKey: ['ExecutorAllOptionsContext'],
    queryFn: async () => {
      const { data } = await getExecutorOptions();
      return data;
    },
    select: data => {
      return data.map(option => {
        return {
          label: option.description,
          value: option.description,
        };
      });
    },
    onSuccess: (data: ISelectOption[]) => {
      setExecutorOptions(data);
    },
    enabled: isEditing,
  });

  const queryJustificationOptions = useQuery({
    queryKey: ['JustificationOptionsContext'],
    queryFn: async () => {
      const { data } = await getJustificationOptions();
      return data;
    },
    select: data => {
      return data.map(option => {
        return {
          label: option.description,
          value: option.id,
        };
      });
    },
    onSuccess: (data: ISelectOption[]) => {
      setJustificationOptions(data);
    },
    enabled: true,
  });

  const sorting = React.useMemo<Sorting[]>(
    () =>
      columns.map(column => {
        return {
          columnName: column.name,
          direction: column.direction,
        } as Sorting;
      }),
    [columns],
  );

  const editingStateColumnExtensions = React.useMemo(
    () =>
      columns.map(column => {
        return {
          columnName: column.name,
          editingEnabled: Boolean(column?.editingEnabled),
        };
      }),
    [columns],
  );

  const [tableColumnExtensions] = useState<Table.ColumnExtension[]>(
    columns.map(column => {
      return {
        columnName: column.name,
        width: column.width,
        align: column.align,
        wordWrapEnabled: true,
      } as Table.ColumnExtension;
    }),
  );
  const [columnWidths, setColumnWidths] = useState<TableColumnWidthInfo[]>(
    columns.map(column => {
      return {
        columnName: column.name,
        width: column.width,
      } as TableColumnWidthInfo;
    }),
  );

  const mappedColumns = React.useMemo<Column[]>(() => {
    return columns.map(column => {
      return {
        name: column.name,
        title: column.title,
      } as Column;
    });
  }, [columns]);

  const sortColumnsData = React.useMemo(() => {
    const columnsData = {};

    columns.forEach(({ name, sortingEnabled }) => {
      columnsData[name] = sortingEnabled;
    });
    return columnsData;
  }, [columns]);

  const disabledSelectionButtonsConcluido = React.useMemo(() => {
    // a linha só é habilitada quando tem uma apenas 1 linha selecionada
    return !(selection?.length > 0);
  }, [selection]);
  const disabledSelectionButtons = React.useMemo(() => {
    // a linha só é habilitada quando tem uma apenas 1 linha selecionada
    return !(selection?.length === 1);
  }, [selection]);
  const disabledSelectionButtonsSeveral = React.useMemo(() => {
    return selection?.length < 1;
  }, [selection]);

  const getFirstSelectedRow = React.useMemo(() => {
    if (disabledSelectionButtons) return null;

    const rowId = selection[0];
    const row = getRowById(rowId);

    return row || null;
  }, [disabledSelectionButtons, getRowById, selection]);

  const getSelectedRows = React.useMemo(() => {
    return selection.map(rowId => {
      return getRowById(rowId) as IRow;
    });
  }, [getRowById, selection]);

  // const disableFinishButton = React.useMemo(() => {
  //   return (
  //     selection?.length === 0 ||
  //     getSelectedRows.some(
  //       row =>
  //         Boolean(row?.realCompletion) ||
  //         Boolean(row?.realEnd) ||
  //         Boolean(row?.status === 'Cancelado') ||
  //         Boolean(row?.status === 'Pausado') ||
  //         Boolean(row?.isInspection === 'S'),
  //     )
  //   );
  // }, [getSelectedRows, selection?.length]);
  const disableFinishButton = React.useMemo(() => {
    return (
      selection?.length === 0 ||
      getSelectedRows.some(
        row =>
          Boolean(row?.realCompletion) ||
          row?.status === 'Cancelado' ||
          row?.status === 'Pausado' ||
          row?.status === 'Concluído' ||
          row?.isInspection === 'S',
      )
    );
  }, [getSelectedRows, selection?.length]);

  const disableReplanButton = React.useMemo(() => {
    // o botão replanejar será desabilitado se existir mais de 1 linha selecionada
    // OU existir valor para a coluna inicio real
    return (
      // Boolean(disabledSelectionButtons) ||
      // Boolean(getFirstSelectedRow?.realStart) ||
      Boolean(disabledSelectionButtonsSeveral) ||
      getSelectedRows.some(row => row?.status === 'Cancelado' || row?.realStart)
    );
  }, [disabledSelectionButtonsSeveral, getSelectedRows]);

  const disablePauseButton = React.useMemo(() => {
    // o botão pausar será desabilitado se existir mais de 1 linha selecionada
    // OU existir valor para a coluna término real
    // OU não existir valor para a coluna realStart
    // OU possui valor para a coluna pauseStart E não possuir o valor da coluna de pauseEnd
    return (
      Boolean(disabledSelectionButtons) ||
      Boolean(getFirstSelectedRow?.realEnd) ||
      getSelectedRows.some(row => row?.status === 'Cancelado') ||
      !getFirstSelectedRow?.realStart ||
      Boolean(getFirstSelectedRow?.pauseStart && !getFirstSelectedRow?.pauseEnd)
    );
  }, [
    disabledSelectionButtons,
    getFirstSelectedRow?.pauseStart,
    getFirstSelectedRow?.realEnd,
    getFirstSelectedRow?.realStart,
    getFirstSelectedRow?.pauseEnd,
  ]);

  const disableResumeButton = React.useMemo(() => {
    // o botão retomar será desabilitado se existir mais de 1 linha selecionada
    // OU existir valor para a coluna término real
    // OU não existir valor para a coluna pauseStart
    return (
      Boolean(disabledSelectionButtons) ||
      Boolean(getFirstSelectedRow?.realEnd) ||
      Boolean(!getFirstSelectedRow?.pauseStart)
    );
  }, [
    disabledSelectionButtons,
    getFirstSelectedRow?.realEnd,
    getFirstSelectedRow?.pauseStart,
  ]);

  const disabledSelectionButtonDelete = React.useMemo(() => {
    // a linha só é habilitada quando tem 1 linha ou mais selecionadas
    return selection?.length === 0;
  }, [selection]);

  const disabledSelectionButtonCancel = React.useMemo(() => {
    // a linha só é habilitada quando tem 1 linha ou mais selecionadas
    return selection?.length === 0;
  }, [selection]);

  const disableCancelButton = React.useMemo(() => {
    return (
      disabledSelectionButtonCancel ||
      getSelectedRows.some(
        row => Boolean(row?.realEnd) || row?.status === 'Cancelado',
      )
    );
  }, [disabledSelectionButtonCancel, getSelectedRows]);

  const canSave = React.useMemo(() => {
    // se esta editando E NÃO se existe algum erro em alguma linha
    return (
      isEditing &&
      !Object.values(errors).some(rowId =>
        Object.values(rowId).some(row => !row.isValid),
      )
    );
  }, [errors, isEditing]);

  const disableEditingButton = React.useMemo(() => {
    return (
      disabledSelectionButtonDelete ||
      getSelectedRows.some(row => Boolean(row?.realEnd))
    );
  }, [disabledSelectionButtonDelete, getSelectedRows]);

  // const disableDeleteButton = React.useMemo(() => {
  //   return (
  //     disabledSelectionButtonDelete ||
  //     getSelectedRows.some(
  //       row => Boolean(row?.realStart) || Boolean(row?.realEnd),
  //     )
  //   );
  // }, [disabledSelectionButtonDelete, getSelectedRows]);

  const CellTooltip = React.useCallback(
    props => (
      <DataTypeProvider
        for={tooltipCells}
        formatterComponent={({ value }) => {
          return DataTypeFormatters.TooltipCellFormatter({
            value,
            tooltipMaxStrLength,
          });
        }}
        {...props}
      />
    ),
    [tooltipCells, tooltipMaxStrLength],
  );

  const CellStatus = React.useCallback(
    props => (
      <DataTypeProvider
        for={statusCells}
        formatterComponent={({ row: { status } }) => {
          const iconMap = {
            Cancelado: (
              <ErrorIcon style={{ color: colors.statusCancelError }} />
            ),
            Pausado: (
              <PauseCircleFilledIcon style={{ color: colors.statusPaused }} />
            ),
            Atrasado: (
              <ReportProblemIcon style={{ color: colors.lateStatus }} />
            ),
            Concluído: (
              <CheckCircleIcon style={{ color: colors.statusCompleted }} />
            ),
            'Em andamento': (
              <CachedIcon style={{ color: colors.statusInProgress }} />
            ),
            Programado: (
              <EventIcon style={{ color: colors.statusProgrammed }} />
            ),
            default: <ErrorIcon style={{ color: colors.statusCancelError }} />,
          };

          return DataTypeFormatters.StatusCellFormatter({
            status,
            iconMap,
          });
        }}
        {...props}
      />
    ),
    [statusCells],
  );

  const ButtonFormatter = React.useCallback(
    ({ row, value }) => {
      return (
        <Button
          onClick={() => {
            setCommentRow(row);
          }}
          color="primary"
          className={classes.buttonText}
        >
          {value}
        </Button>
      );
    },
    [classes.buttonText],
  );

  const CellButton = React.useCallback(
    props => (
      <DataTypeProvider
        for={buttonCells}
        formatterComponent={ButtonFormatter}
        {...props}
      />
    ),
    [ButtonFormatter, buttonCells],
  );

  const CellDayMonth = React.useCallback(
    props => (
      <DataTypeProvider
        for={dayMonthCells}
        formatterComponent={({ value }) => {
          return DataTypeFormatters.DateCellFormatter({
            value,
            format: 'DD/MM',
          });
        }}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled)
            return DataTypeFormatters.DateCellFormatter({
              value,
              format: 'DD/MM',
            });

          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          return DataTypeEditors.DateEditorComponent({
            format: 'DD/MM',
            error: hasError,
            value,
            onValueChange,
            placeholder: '',
          });
        }}
        {...props}
      />
    ),
    [dayMonthCells, errors, getRowId],
  );

  const CellDayMonthYear = React.useCallback(
    props => (
      <DataTypeProvider
        for={dayMonthYearCells}
        formatterComponent={({ value }) => {
          return DataTypeFormatters.DateCellFormatter({
            value,
            format: 'DD/MM/YY',
          });
        }}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled)
            return DataTypeFormatters.DateCellFormatter({
              value,
              format: 'DD/MM/YY',
            });

          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          return DataTypeEditors.DateEditorComponent({
            format: 'DD/MM/YY',
            error: hasError,
            value,
            onValueChange,
            placeholder: '',
          });
        }}
        {...props}
      />
    ),
    [dayMonthYearCells, errors, getRowId],
  );

  const CellDate = React.useCallback(
    props => (
      <DataTypeProvider
        for={dateCells}
        formatterComponent={({ value }) => {
          return DataTypeFormatters.DateCellFormatter({
            value,
            format: 'DD/MM/YY',
          });
        }}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled) {
            return DataTypeFormatters.DateCellFormatter({
              value,
              format: 'DD/MM/YY',
            });
          }

          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          return DataTypeEditors.DateEditorComponent({
            format: 'DD/MM/YY',
            error: hasError,
            value,
            onValueChange,
            placeholder: '',
          });
        }}
        {...props}
      />
    ),
    [dateCells, errors, getRowId],
  );

  const CellDateTime = React.useCallback(
    props => (
      <DataTypeProvider
        for={dateTimeCells}
        formatterComponent={({ value }) => {
          const date = dayjs(value);
          let DateTimeformatter = 'DD/MM/YY HH:mm';
          if (date.hour() === 0 && date.minute() === 0) {
            DateTimeformatter = 'DD/MM/YY';
          }

          return DataTypeFormatters.DateCellFormatter({
            value,
            format: DateTimeformatter,
          });
        }}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (!disabled && row?.status === 'Em andamento') {
            const rowId = getRowId(row);
            const hasError =
              Boolean(errors[rowId]?.[column.name]) &&
              !errors[rowId]?.[column.name]?.isValid;

            return DataTypeEditors.DateTimeEditorComponent({
              format: 'DD/MM/YY HH:mm',
              error: hasError,
              value,
              onValueChange,
              placeholder: '',
            });
          }

          return DataTypeFormatters.DateCellFormatter({
            value,
            format: 'DD/MM/YY HH:mm',
          });
        }}
        {...props}
      />
    ),
    [dateTimeCells, errors, getRowId],
  );

  const CellDuration = React.useCallback(
    props => (
      <DataTypeProvider
        for={durationCells}
        formatterComponent={({ value }) => {
          return DataTypeFormatters.DurationCellFormatter({
            value: Number(value),
          });
        }}
        {...props}
      />
    ),
    [durationCells],
  );

  const CellExternalLink = React.useCallback(
    props => (
      <DataTypeProvider
        for={externalLinkCells}
        formatterComponent={({ value }) => {
          return DataTypeFormatters.ExternalLinkCellFormatter({
            value,
          });
        }}
        {...props}
      />
    ),
    [externalLinkCells],
  );

  const CellYesOrNot = React.useCallback(
    props => {
      const textMap = {
        Y: 'Sim',
        S: 'Sim',
        N: 'Não',
        default: 'Não',
      };

      return (
        <DataTypeProvider
          for={yesOrNotCells}
          formatterComponent={({ value }) => {
            return DataTypeFormatters.TextOptionsCellFormatter({
              value,
              textMap,
            });
          }}
          editorComponent={({
            column,
            row,
            value,
            onValueChange,
            disabled,
          }) => {
            if (disabled) {
              return DataTypeFormatters.TextOptionsCellFormatter({
                value,
                textMap,
              });
            }
            const rowId = getRowId(row);
            const hasError =
              Boolean(errors[rowId]?.[column.name]) &&
              !errors[rowId]?.[column.name]?.isValid;

            return DataTypeEditors.SelectOptionsEditorComponent({
              options: yesOrNotOptions,
              isLoading: queryYesOrNot?.isLoading,
              error: hasError,
              value,
              onValueChange,
            });
          }}
          {...props}
        />
      );
    },
    [
      yesOrNotCells,
      getRowId,
      errors,
      yesOrNotOptions,
      queryYesOrNot?.isLoading,
    ],
  );

  const CellPercentage = React.useCallback(
    props => {
      return (
        <DataTypeProvider
          for={percentageCells}
          formatterComponent={({ row: { status }, value }) => {
            const textMap = {
              Programado: '0',
              Concluído: '100',
              default: value,
            };

            return DataTypeFormatters.TextOptionsCellFormatter({
              value: status,
              textMap,
            });
          }}
          editorComponent={({
            column,
            row,
            value,
            onValueChange,
            disabled,
          }) => {
            if (disabled) {
              const textMap = {
                Programado: '0',
                Concluído: '100',
                default: value,
              };

              return DataTypeFormatters.TextOptionsCellFormatter({
                value,
                textMap,
              });
            }

            const rowId = getRowId(row);
            const hasError =
              Boolean(errors[rowId]?.[column.name]) &&
              !errors[rowId]?.[column.name]?.isValid;

            return DataTypeEditors.InputNumberEditorComponent({
              value,
              error: hasError,
              onValueChange,
            });
          }}
          {...props}
        />
      );
    },
    [errors, getRowId, percentageCells],
  );

  const CellMaintenanceType = React.useCallback(
    props => (
      <DataTypeProvider
        // TODO: refatorar para ser via props a partir do comp pai
        for={['maintenanceType']}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled) return value;

          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          const valueId = typeMaintranceOptions.find(
            item => item.label === value || item.value === value,
          )?.value;

          return DataTypeEditors.SelectOptionsEditorComponent({
            options: typeMaintranceOptions,
            isLoading: queryMaintenanceTypeOptions?.isLoading,
            error: hasError,
            value: valueId,
            onValueChange,
          });
        }}
        {...props}
      />
    ),
    [
      errors,
      getRowId,
      queryMaintenanceTypeOptions?.isLoading,
      typeMaintranceOptions,
    ],
  );

  const CellExecutor = React.useCallback(
    props => (
      <DataTypeProvider
        // TODO: refatorar para ser via props a partir do comp pai
        for={['executor']}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled) return value;

          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          const valueId = executorOptions.find(
            item => item.label === value || item.value === value,
          )?.value;

          return DataTypeEditors.SelectOptionsEditorComponent({
            options: executorOptions,
            isLoading: queryExecutorAllOptions?.isLoading,
            error: hasError,
            value: valueId,
            onValueChange,
          });
        }}
        {...props}
      />
    ),
    [errors, executorOptions, getRowId, queryExecutorAllOptions?.isLoading],
  );

  const CellJustification = React.useCallback(
    props => (
      <DataTypeProvider
        // TODO: refatorar para ser via props a partir do comp pai
        for={['justification']}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled) return value;

          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          const valueId = justificationOptions.find(
            item => item.label === value || item.value === value,
          )?.value;

          return DataTypeEditors.SelectOptionsEditorComponent({
            options: justificationOptions,
            isLoading: queryJustificationOptions?.isLoading,
            error: hasError,
            value: valueId,
            onValueChange,
          });
        }}
        {...props}
      />
    ),
    [
      errors,
      getRowId,
      justificationOptions,
      queryJustificationOptions?.isLoading,
    ],
  );

  const CellFrequency = React.useCallback(
    props => (
      <DataTypeProvider
        // TODO: refatorar para ser via props a partir do comp pai
        for={['frequency']}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled) return value;
          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          return DataTypeEditors.InputNumberEditorComponent({
            error: hasError,
            value,
            onValueChange,
          });
        }}
        {...props}
      />
    ),
    [errors, getRowId],
  );

  const CellReport = React.useCallback(
    props => (
      <DataTypeProvider
        // TODO: refatorar para ser via props a partir do comp pai
        for={['report']}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled) return value;
          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          return DataTypeEditors.InputTextEditorComponent({
            error: hasError,
            value,
            onValueChange,
          });
        }}
        {...props}
      />
    ),
    [errors, getRowId],
  );


  const CellObservationField = React.useCallback(
    props => (
      <DataTypeProvider
        // TODO: refatorar para ser via props a partir do comp pai
        for={['observationField']}
        editorComponent={({ column, row, value, onValueChange, disabled }) => {
          if (disabled) return value;
          const rowId = getRowId(row);
          const hasError =
            Boolean(errors[rowId]?.[column.name]) &&
            !errors[rowId]?.[column.name]?.isValid;

          return DataTypeEditors.InputTextEditorComponent({
            error: hasError,
            value,
            onValueChange,
          });
        }}
        {...props}
      />
    ),
    [errors, getRowId],
  );

  const SortingIcon = React.useCallback(
    () => <SvgIcon component={SvgSortIcon} />,
    [],
  );

  const renderSortLabel = React.useCallback(
    ({ children, onSort, column }) => {
      return (
        <>
          {children}
          {sortColumnsData[column.name] && (
            <IconButton
              className={classes.iconButtonContainer}
              onClick={onSort}
            >
              <SortingIcon />
            </IconButton>
          )}
        </>
      );
    },
    [SortingIcon, classes.iconButtonContainer, sortColumnsData],
  );

  const renderTableSelectionRowComponent = React.useCallback(
    props => {
      const { highlighted, tableRow } = props;

      const extraStyles = {} as React.CSSProperties;

      const criticalityBackgrounds = {
        [CRITICALITY_DEGREE.HIGH]: CriticalityColors.high,
        [CRITICALITY_DEGREE.VERY_HIGH]: CriticalityColors.veryHigh,
        [CRITICALITY_DEGREE.MEDIUM]: CriticalityColors.medium,
        [CRITICALITY_DEGREE.LOW]: CriticalityColors.low,
      };

      if (criticalityBackgrounds[tableRow.row?.criticalityDegree]) {
        extraStyles.backgroundColor =
          criticalityBackgrounds[tableRow.row?.criticalityDegree];
      }

      return (
        <Table.Row
          {...props}
          style={extraStyles}
          className={highlighted ? classes.selectedRows : null}
        />
      );
    },
    [classes.selectedRows],
  );

  const renderTitleComponent = React.useCallback(
    props => {
      const { children } = props;
      const columnData = columns.find(column => column.title === children);

      if (columnData?.fullTitle) {
        const renderTitle = () => (
          <span className={classes.tooltipLabel}>{columnData?.fullTitle}</span>
        );

        return (
          <TableHeaderRow.Title className={classes.tableTitle} {...props}>
            <Tooltip title={renderTitle()}>
              <span>{children}</span>
            </Tooltip>
          </TableHeaderRow.Title>
        );
      }

      return <TableHeaderRow.Title className={classes.tableTitle} {...props} />;
    },
    [classes.tableTitle, classes.tooltipLabel, columns],
  );

  const updateColumnOrder = React.useCallback(
    colsOrder => {
      setColumnOrder(colsOrder);

      onSaveGridConfiguration({
        order: colsOrder,
        columns: columnWidths,
      });
    },
    [columnWidths, onSaveGridConfiguration],
  );

  const updateColumnWidth = React.useCallback(
    colsWidth => {
      setColumnWidths(colsWidth);

      onSaveGridConfiguration({
        order: columnOrder,
        columns: colsWidth,
      });
    },
    [columnOrder, onSaveGridConfiguration],
  );

  const commitChanges = React.useCallback(
    ({ changed }) => {
      // 1 recupere apenas as linhas que foram editadas
      const editedRows = rows.filter(row =>
        Object.keys(changed).includes(`${row.id}`),
      );
      // 2 recupere e monte o objeto com todos os valores das linhas editadas
      const changedRows = editedRows.map(row =>
        changed[row.id] ? { ...row, ...changed[row.id] } : row,
      );

      changedRows.forEach(r => {
        // alterar em prod
        if (!isNumber(r.justification)) {
          // eslint-disable-next-line no-param-reassign
          r.justification = r.justificationId;
        }
      });
      setUpdatingGridData(true);
            // enviar dados para o servidor
      postActivityUpdate({ plannedActivitiesToUpdate: changedRows })
        .then(() => {
          // se requisição der OK
          // chamar o método de reload
          if (refetch) refetch();
        })
        .finally(() => {
          setUpdatingGridData(false);
          queryClient.invalidateQueries();
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refetch, rows],
  );

  const editingSelectedColumns = React.useCallback(() => {
    if (isEditing) {
      if (Object.keys(rowChanges).length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newRowChanges: any = rowChanges;
        if (newRowChanges.justification) {
          newRowChanges.justification = newRowChanges.justificationId;
        }
        commitChanges({ changed: newRowChanges });
      }
      setEditingRowIds([]);
      setIsEditing(false);
      setSelection([]);
    } else {
      setEditingRowIds(selection);
      setIsEditing(true);
    }
  }, [isEditing, commitChanges, rowChanges, selection]);

  const RowEditingComponent = React.useCallback(
    props => {
            return <Table.Row {...props} className={classes.selectedRows} />;
    },
    [classes.selectedRows],
  );

  const CellEditingComponent = React.useCallback(
    props => {
      const {
        tableRow: { rowId },
        column: { name: columnName },
      } = props;
            const columnStatus = errors[rowId]?.[columnName];
      const valid = !columnStatus || columnStatus.isValid;
      const title = valid ? '' : errors[rowId][columnName].error;

      return <Table.Cell {...props} title={title} />;
    },
    [errors],
  );

  const validate = (editedRows: { [key: string]: IRow }): IValidationRules =>
    Object.entries(editedRows).reduce((acc, [rowId, partialRow]) => {
      const validatedFields = {};
      Object.entries(partialRow).forEach(([colName, colValue]) => {
        if (validationRules && validationRules[colName]) {
          const row = { ...(getRowById(rowId) || ({} as IRow)), ...partialRow };
          validatedFields[colName] = {
            isValid: validationRules[colName].isValid(colValue, row),
            error: validationRules[colName].errorText,
          };
        }
      });

      return {
        ...acc,
        [rowId]: validatedFields,
      };
    }, {});

  const onEdited = debounce(edited => {
    const rowsValidated = validate(edited);

    setErrors(rowsValidated);
  }, 250);

  const startInspection = React.useMemo(() => {
    return getFirstSelectedRow?.isInspection === 'S';
  }, [getFirstSelectedRow?.isInspection]);

  const disableStartButton = React.useMemo(() => {
    return (
      selection?.length !== 1 ||
      getSelectedRows.some(
        row =>
          Boolean(row?.realCompletion) ||
          Boolean(row?.realStart) ||
          row?.status === 'Cancelado',
      )
    );
  }, [getSelectedRows, selection?.length]);

  React.useEffect(() => {
    // Atualiza a ordem das colunas
    setColumnOrder(orderOfColumns);
  }, [orderOfColumns]);

  React.useEffect(() => {
    // Atualiza a largura das colunas
    if (widthOfColumns) setColumnWidths(widthOfColumns);
  }, [widthOfColumns]);

  useLayoutEffect(() => {
    const rootBase = gridRef?.current?.firstChild; // Obtem o elemento RootBase da Grid
    const tableRootContainer = rootBase?.firstChild as HTMLElement; // Container da Tabela para adicionar o evento de scroll horizontal
    const tableOuterDiv = tableRootContainer?.firstChild; // O componente gera uma div pura entre a tabela e o seu container
    const table = tableOuterDiv?.firstChild as HTMLElement; // Elemento da tabela para obter a sua largura

    const hiddenScrollDiv = hiddenScrollDivRef.current as HTMLElement; // Elemento dentro da div externa que possuirá o mesmo tamanho da tabela para scroll externo
    hiddenScrollDiv.style.width = `${table?.offsetWidth + 85}px`; // Atribui a largura da tabela + 85px da Coluna de Checkbox

    const scrollDiv = scrollDivRef.current as HTMLElement; // Elemento onde será colocado o scroll externo

    // Função que será executada ao rolar o scroll externo
    const scrollListener = ({ target }) => {
      const currentScroll = target as HTMLElement;
      tableRootContainer.scrollLeft = currentScroll.scrollLeft; // Scroll da tabela reflete a posição do scroll externo
    };
    scrollDiv.removeEventListener('scroll', scrollListener); // Quando a largura do grid mudar, remover o listener antes de adicionar um novo
    scrollDiv.addEventListener('scroll', scrollListener); // Adicionar o listener para o scroll externo

    return () => scrollDiv.removeEventListener('scroll', scrollListener); // Remover listener ao desmontar o componente
  }, [columnWidths]); // Observar a mudança da largura do grid

  React.useEffect(() => {
    // obtendo todos os ids das linhas da grid
    const rowIds = rows.map(row => getRowId(row));

    /**
     * Atualizo a lista de seleções para corresponder
     * apenas as linhas que estão sendo exibidas.
     */
    setSelection(currentValues => {
      return currentValues.filter(item => rowIds.includes(item));
    });
  }, [getRowId, rows]);

  return (
    <MuiAccordion
      className={classes.accordionContainer}
      square
      expanded={expandAccordion}
    >
      <AccordionSummary
        className={classes.accordionSummary}
        aria-controls="planning-grid-accordion"
      >
        <div className={classes.buttonsActionsContainer}>
          <div className={classes.buttonsActionsContainerLeft}>
            <Button
              onClick={() => setExpandAccordion(oldValue => !oldValue)}
              color="primary"
            >
              {expandAccordion
                ? 'Ocultar Lista de Atividades'
                : 'Visualizar Lista de Atividades'}
            </Button>
          </div>

          <div className={classes.buttonsActionsContainerRight}>
            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalStartInspection
                open={modalStarInspection}
                onClose={() => setModalStartInspection(false)}
                gridRow={getFirstSelectedRow}
              >
                <ModalStart
                  open={openModalStart}
                  onClose={() => setOpenModalStart(false)}
                  selectedRow={getFirstSelectedRow}
                  reloadData={refetch}
                >
                  <WrapperWithTooltip
                    condition={getSelectedRows.some(
                      row =>
                        Boolean(row?.realCompletion) ||
                        Boolean(row?.realStart) ||
                        Boolean(row?.status === 'Cancelado'),
                    )}
                    tooltipMessage="Não é possível iniciar uma atividade com data de início real, término real ou com status de cancelada"
                  >
                    <Button
                      onClick={() => {
                        if (startInspection) {
                          setModalStartInspection(true);
                        } else {
                          setOpenModalStart(true);
                        }
                      }}
                      disabled={disableStartButton}
                      color="primary"
                    >
                      Iniciar
                    </Button>
                  </WrapperWithTooltip>
                </ModalStart>
              </ModalStartInspection>
            </Hide>

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalFinish
                open={openModalFinish}
                onClose={() => setOpenModalFinish(false)}
                selectedRows={getSelectedRows}
                reloadData={refetch}
              >
                <WrapperWithTooltip
                  condition={getSelectedRows.some(
                    row =>
                      Boolean(row?.realCompletion) ||
                      Boolean(row?.realEnd) ||
                      Boolean(row?.status === 'Pausado') ||
                      Boolean(row?.status === 'Concluído') ||
                      Boolean(row?.status === 'Cancelado'),
                  )}
                  tooltipMessage="Não é possível concluir uma atividade com data de término real ou com status de cancelada/pausada/concluída "
                >
                  <WrapperWithTooltip
                    condition={getSelectedRows.some(
                      row => row?.isInspection === 'S' && !row?.realCompletion,
                    )}
                    tooltipMessage="Atividades precisam ser realizadas para serem concluídas."
                  >
                    <Button
                      onClick={() => setOpenModalFinish(true)}
                      disabled={disableFinishButton}
                      color="primary"
                    >
                      Concluir
                    </Button>
                  </WrapperWithTooltip>
                </WrapperWithTooltip>
              </ModalFinish>
            </Hide>

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalReplanning
                open={modalReplannig}
                onClose={() => setModalReplanning(false)}
                selectedRows={getSelectedRows}
                reloadData={refetch}
              >
                <Button
                  disabled={disableReplanButton}
                  color="primary"
                  onClick={() => setModalReplanning(true)}
                >
                  Replanejar
                </Button>
              </ModalReplanning>
            </Hide>

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalPause
                open={openModalPause}
                onClose={() => setOpenModalPause(false)}
                gridRow={getFirstSelectedRow}
                reloadData={refetch}
              >
                <Button
                  onClick={() => setOpenModalPause(true)}
                  disabled={disablePauseButton}
                  color="primary"
                >
                  Pausar
                </Button>
              </ModalPause>
            </Hide>

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalUnpause
                open={modalUnpause}
                onClose={() => setModalUnpause(false)}
                gridRow={getFirstSelectedRow}
                reloadData={refetch}
              >
                <Button
                  onClick={() => setModalUnpause(true)}
                  disabled={disableResumeButton}
                  color="primary"
                >
                  Retomar
                </Button>
              </ModalUnpause>
            </Hide>

            {/* INÍCIO DIVISÃO DA AÇÃO DE EDITAR */}
            <Hide
              hide={
                !checkPermissions([GROUPS.ADMINISTRATOR, GROUPS.PLANNING]) ||
                isEditing
              }
            >
              <WrapperWithTooltip
                condition={getSelectedRows.some(row => Boolean(row?.realEnd))}
                tooltipMessage="Não é possível editar uma atividade finalizada"
              >
                <Button
                  disabled={disableEditingButton}
                  onClick={editingSelectedColumns}
                  color="primary"
                >
                  Editar
                </Button>
              </WrapperWithTooltip>
            </Hide>

            <Hide
              hide={
                !checkPermissions([GROUPS.ADMINISTRATOR, GROUPS.PLANNING]) ||
                !isEditing
              }
            >
              <WrapperWithTooltip
                condition={!canSave}
                tooltipMessage="Existem campos inválidos na grid"
              >
                <Button
                  disabled={!canSave}
                  onClick={editingSelectedColumns}
                  color="primary"
                >
                  Salvar
                </Button>
              </WrapperWithTooltip>
            </Hide>
            {/* INÍCIO DIVISÃO DA AÇÃO DE EDITAR */}

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <ModalAdd
                open={modalAdd}
                onClose={() => setModalAdd(false)}
                reloadData={refetch}
              >
                <Button onClick={() => setModalAdd(true)} color="primary">
                  Adicionar
                </Button>
              </ModalAdd>
            </Hide>

            <Hide
              hide={
                !checkPermissions([
                  GROUPS.ADMINISTRATOR,
                  GROUPS.ENGINEERING,
                  GROUPS.PLANNING,
                  GROUPS.TECHNICIAN,
                ])
              }
            >
              <GridModalCancel
                open={modalCancel}
                onClose={() => setModalCancel(false)}
                selectedRows={getSelectedRows}
                reloadData={refetch}
                cancelService={postCancelActivity}
              >
                <WrapperWithTooltip
                  condition={getSelectedRows.some(row => Boolean(row?.realEnd))}
                  tooltipMessage="Não é possível cancelar uma atividade finalizada"
                >
                  <Button
                    onClick={() => setModalCancel(true)}
                    disabled={disableCancelButton}
                    color="primary"
                  >
                    Cancelar
                  </Button>
                </WrapperWithTooltip>
              </GridModalCancel>
            </Hide>

            <Hide
              hide={!checkPermissions([GROUPS.ADMINISTRATOR, GROUPS.PLANNING])}
            >
              <GridModalDelete
                open={modalDelete}
                onClose={() => setModalDelete(false)}
                selectedRows={getSelectedRows}
                service={deleteActivityPlanned}
                reloadData={refetch}
                idPlan="activityPlanId"
                idReal="activityRealId"
                idKey=""
                idDiverse="activityDiverseId"
              >
                {/* <WrapperWithTooltip
                  condition={getSelectedRows.some(
                    row => Boolean(row?.realStart) || Boolean(row?.realEnd)
                  )}
                  tooltipMessage="Não é possível excluir uma atividade com data de início real ou término real"
                > */}
                <Button
                  onClick={() => setModalDelete(true)}
                  disabled={disabledSelectionButtonsConcluido}
                  color="secondary"
                >
                  Excluir
                </Button>
                {/* </WrapperWithTooltip> */}
              </GridModalDelete>
            </Hide>

            <IconButton onClick={onExport}>
              <Tooltip
                title={
                  <span className={classes.tooltipLabel}>Exportar Dados</span>
                }
              >
                <GetAppIcon color="primary" />
              </Tooltip>
            </IconButton>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Paper
          variant="elevation"
          elevation={0}
          ref={gridRef}
          className={classes.container}
        >
          <Grid getRowId={getRowId} rows={rows} columns={mappedColumns}>
            <SelectionState
              selection={selection}
              onSelectionChange={setSelection}
            />
            <SortingState sorting={sorting} onSortingChange={onSortingChange} />
            <IntegratedSelection />
            <DragDropProvider />
            <CellTooltip />
            <CellStatus />
            <CellButton />
            <CellDayMonth />
            <CellDayMonthYear />
            <CellDate />
            <CellDateTime />
            <CellDuration />
            <CellExternalLink />
            <CellYesOrNot />
            <CellPercentage />
            <CellMaintenanceType />
            <CellExecutor />
            <CellJustification />
            <CellFrequency />
            <CellReport />
            <CellObservationField/>
            <EditingState
              editingRowIds={editingRowIds}
              rowChanges={rowChanges}
              onRowChangesChange={newChangedRows => {
                onEdited(newChangedRows);
                setRowChanges(newChangedRows);
              }}
              onCommitChanges={commitChanges}
              columnExtensions={editingStateColumnExtensions}
            />
            <PagingState
              currentPage={currentPage}
              onCurrentPageChange={onCurrentPageChange}
              pageSize={pageSize}
              onPageSizeChange={onPageSizeChange}
            />
            <CustomPaging totalCount={totalCount} />
            <Table
              messages={tableMessages}
              cellComponent={props => {
                const { column, row } = props;
                const cellValue = row[column.name];
                if (cellValue) return <Table.Cell {...props} />;
                return <Table.Cell {...props}> - </Table.Cell>;
              }}
              columnExtensions={tableColumnExtensions}
            />
            <TableColumnResizing
              columnWidths={columnWidths}
              onColumnWidthsChange={updateColumnWidth}
            />
            <TableColumnReordering
              order={columnOrder}
              onOrderChange={updateColumnOrder}
            />
            <TableHeaderRow
              titleComponent={renderTitleComponent}
              sortLabelComponent={renderSortLabel}
              showSortingControls
            />
            <TableEditRow
              rowComponent={RowEditingComponent}
              cellComponent={CellEditingComponent}
            />
            <TableSelection
              rowComponent={renderTableSelectionRowComponent}
              highlightRow
              showSelectAll
            />
            <TableFixedColumns
              cellComponent={props => (
                <TableFixedColumns.Cell {...props} showRightDivider={false} />
              )}
              leftColumns={[TableSelection.COLUMN_TYPE, ...fixedLeftColumns]}
            />
            <PagingPanel messages={pagingPanelMessages} pageSizes={pageSizes} />

            <PluginComments
              commentRow={commentRow}
              onClose={() => {
                setCommentRow({});
              }}
            />
          </Grid>
          <div ref={scrollDivRef} className={classes.scrollDiv}>
            <div ref={hiddenScrollDivRef} className={classes.hiddenScrollDiv} />
          </div>
          {(loading || updatingGridData) && <Loading />}
        </Paper>
      </AccordionDetails>
    </MuiAccordion>
  );
};

export default PlanningGrid;
